/**
 * Banner Capabilities Flags
 */
define([], function () {
  return [
    '970x250', //IAB Billboard (970x250)
    '120x60', //IAB Button 2 (120x60)
    '300x600', //IAB Halfpage/Filmstrip (300x600)
    '728x90', //IAB Leaderboard (728x90)
    '970x100', //IAB Leaderboard (970x100)
    '300x250', //IAB Medium Rectangle (300x250)
    '88x31', //IAB Microbar (88x31)
    '300x1050', //IAB Portrait (300x1050)
    '970x90', //IAB Pushdown (970x90)
    '180x150', //IAB Rectangle (180x150)
    '320x480', //IAB Smartphone Portrait (320x480)
    '300x50', //IAB Smartphone Static Banner (300x50)
    '320x50', //IAB Smartphone Static Wide Banner (320x50)
    '300x300', //IAB Square (300x300)
    '970x66', //IAB Super Leaderboard (970x66)
    '160x600' //IAB Wide Skyscraper (160x600)
  ];
});



//////////////////
// WEBPACK FOOTER
// ./src/base/ad/BannerCapabilityFlags.js
// module id = 110
// module chunks = 0